let tabs = document.querySelectorAll('.tabs__toggle'),
   container = document.querySelector('.navigation-drawer'),
   contents = document.querySelectorAll('.tabs__content'),
   nav = document.getElementById('header-drawer');

tabs.forEach((tab, index) => {
   tab.addEventListener('click', () => {
      const currentIndex = tab.classList.contains('is-active');
      nav.classList.add('switched');
      container.classList.remove('-hidden');
      contents.forEach((content) => {
         content.classList.remove('is-active');
      });
      
      tabs.forEach((tab) => {
         tab.classList.remove('is-active');
      });
      
      contents[index].classList.add('is-active');
      tabs[index].classList.add('is-active');
      
      if (currentIndex) {
         container.classList.toggle('-hidden');
         tabs[index].classList.remove('is-active');
         contents[index].classList.remove('is-active');
         nav.classList.remove('switched');
      }
      // container.classList.toggle('-hidden', currentIndex );
   });
});